import {
  IExhibitorsDashboardTranslations,
  IExhibitorTickets,
  IExhibitorExports,
  IExhibitorVisitors,
  IExhibitorSidebar,
  IExhibitorSettingsTranslations,
  IExhibitorProducsTranslations,
  IExhibitorInteractionsTranslations,
  IExhibitorOnboardingTranslations,
  IExhibitorSessions,
  IExhibitorProductInteractions,
  IExhibitorProfile,
} from '@/translations/default/exhibitors';

const dashboard: Partial<IExhibitorsDashboardTranslations> = {
  // leave empty until needed
};

const tickets: Partial<IExhibitorTickets> = {
  // leave empty until needed
};

const exports: Partial<IExhibitorExports> = {
  // leave empty until needed
};

const visitors: Partial<IExhibitorVisitors> = {
  title: 'Candidatos',
  subtitle: 'Ver informação de candidatos e convidar para sessões privadas.',
};

const sidebar: Partial<IExhibitorSidebar> = {
  exhibitor_interactions: 'Candidaturas espontâneas',
  interactions: 'Candidatos',
  product_interactions: 'Candidaturas a ofertas',
  exhibitor_sessions: 'Sessões da empresa',
  products: 'Ofertas de emprego',
};

const settings: Partial<IExhibitorSettingsTranslations> = {
  // leave empty until needed
};

const products: Partial<IExhibitorProducsTranslations> = {
  title: 'Ofertas de emprego',
  subtitle: 'Criar, alterar e apagar ofertas de emprego',
  no_products: 'Nenhum pedido de informação disponível.',
  new_product: 'Nova oferta de emprego',
  create_new_product: 'Criar',
  edit_product: 'Editar oferta de emprego',
  interactions_exist_cannot_delete:
    'Esta oferta já tem candidaturas, por isso não é possível eliminar.',
};

const interactions: Partial<IExhibitorInteractionsTranslations> = {
  title: 'Candidaturas espontâneas',
  subtitle: 'Consultar candidaturas e agendar entrevistas',
  noInteractions: 'Esta empresa não tem candidaturas.',
};

const onboarding: Partial<IExhibitorOnboardingTranslations> = {
  // leave empty until needed
};

const sessions: Partial<IExhibitorSessions> = {
  private_session_warning:
    'Crie uma sessão privada para convidar candidatos específicos para uma entrevista. Se for uma sessão pública, qualquer candidato poderá visualizar e registar-se na sua sessão.',
};

const productInteractions: Partial<IExhibitorProductInteractions> = {
  title: 'Candidaturas a ofertas de emprego',
  subtitle: 'Consultar candidaturas e agendar entrevistas',
  product_name: 'Candidatura',
  interaction_name: 'Nome do candidato',
  application: 'Candidatura',
  empty_list_title: 'As candidaturas às suas ofertas aparecerão aqui',
  empty_list_subtitle: 'Partilhe a sua página de empresa para obter mais interacções',
};

const profile: Partial<IExhibitorProfile> = {
  products: 'Ofertas de emprego',
};

export default {
  dashboard,
  settings,
  interactions,
  onboarding,
  sidebar,
  sessions,
  products,
  productInteractions,
  exports,
  visitors,
  profile,
  tickets,
};
